import React, { Component } from 'react';
import { connect } from 'react-redux';
import { helpImagesState, popupDispatcher, identityState,combineStates,siteSettingsState} from '../store';
import { SvgImage } from '.';
import { HelpImage, InfoIconNew, tipsIcon1,redStarIcon } from '../../style/images';
import { helpImage } from '../util';
import { PropTypes } from 'prop-types';
import { getLanguages,translate } from '../services';
import { NodeMessage } from '.';
import { CategoryItem } from '../components/categoryBrowser/CategoryItem';
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';

const HelpImageContainer = ( { image } ) =><div className="help-image-container">
                                  <div className='help-image-header'>
                                    <div className='line'></div>
                                    <span className='heading'>{this.props.selectorName}</span>
                                  </div>
                                    <img src={ helpImage( image ) } alt={ image } />
                                  <div className='help-image-footer'></div>
                                    </div> ;

export class HelpImageViewerComponent extends Component {

  constructor(props){
    super(props);
  }

  loadHelpImage = () => {
    const { displayName, filterName, helpImages } = this.props;
    let currentImage = this.getCurrentImage();
    if ( !helpImages[currentImage] ) {
      currentImage = this.getDefaultImage();
     }
    
    this.props.setImage(currentImage, this.props.filterName);
    // this.props.setPopup( { 
    //   title : displayName || filterName, 
    //   component : <HelpImageContainer image={ currentImage }/> 
    // } );
  }

  getCurrentImage() {
    const {  filterName, selectorName, customeFilteImageTitle, user,defaultFilter,siteSettings,templateKey,secondImage } = this.props;
    const customeFilterName = customeFilteImageTitle? filterName+customeFilteImageTitle : filterName;
    const helpImageVariables=siteSettings?.properties?.helpImageVariables;
    const doubleImage=helpImageVariables?.map(h=>{return h[templateKey]})?.map(a=>a?.any(b=>{return b==this.props?.filterName}))
    const warningImage=doubleImage && doubleImage[0];
    const defaultFilterUpdated=warningImage && secondImage?defaultFilter.replaceAll('/','')+'_1':defaultFilter.replaceAll('/','');

    var lang='';
    const lang1 = getLanguages().first();
    if(lang1){
      return `${selectorName}_${defaultFilterUpdated}_${lang1}`.toLowerCase();
    }
    else{
      const {culture} = user;
      if(culture.indexOf('-')>0){
        lang = culture.split( '-' )[0].toUpperCase();
     }
     else{
        lang=culture;
     }
     return `${selectorName}_${defauldefaultFilterUpdatedtFilter}_${lang}`.toLowerCase();
    }
    //return `${selectorName}_${customeFilterName}`.toLowerCase();
    // var lang='';
    // const lang1 = getLanguages().first();
    // if(lang1){
    //   return `${selectorName}_${defaultFilter}_${lang1}`.toLowerCase();
    // }
    // else{
    //   const {culture} = user;
    //   if(culture.indexOf('-')>0){
    //     lang = culture.split( '-' )[0].toUpperCase();
    //  }
    //  else{
    //     lang=culture;
    //  }
    //  return `${selectorName}_${defaultFilter}_${lang}`.toLowerCase();
    // }
  }
  getDefaultImage() {
    const {  defaultFilter, selectorName ,siteSettings,templateKey,secondImage} = this.props;
    const helpImageVariables=siteSettings?.properties?.helpImageVariables;
    const doubleImage=helpImageVariables?.map(h=>{return h[templateKey]})?.map(a=>a?.any(b=>{return b==this.props?.filterName}))
    const warningImage=doubleImage && doubleImage[0];
    const defaultFilterUpdated=warningImage && secondImage?defaultFilter.replaceAll('/','')+'_1':defaultFilter.replaceAll('/','');


    return `${selectorName}_${defaultFilterUpdated}`.toLowerCase();

  }


  render() {
    const { helpImages,secondImage } = this.props;
    const currentImage = this.getCurrentImage();
    let helpImage = currentImage.endsWith('_1')?redStarIcon:InfoIconNew;
    if(secondImage && (!currentImage.endsWith('_1_zh'))){
       return null;
    }
     if ( !helpImages[currentImage] ) {
      const defaultImage = this.getDefaultImage();
      if(secondImage && !defaultImage.endsWith('_1')){
        return null;
     }
      helpImage = defaultImage.endsWith('_1')?redStarIcon:InfoIconNew
      if ( !helpImages[defaultImage] ) {
        return null;
      }
      else{
        return<>{
          !this.props.mobileView?
          <MuiIconButton className='product-id-tooltip help-image-icon' disableFocusRipple disableRipple disableTouchRipple onClick={ this.loadHelpImage }>
              <Box sx={{width:"16px", height:"16px"}} component="img" src={helpImage}></Box>
            </MuiIconButton>
          :<span className='mobile-help-image' onClick={this.loadHelpImage}>{translate("See additional information")}</span>
        }</>
      }
     }
    return <MuiIconButton className='product-id-tooltip help-image-icon' disableFocusRipple disableRipple disableTouchRipple onClick={ this.loadHelpImage }>
              <Box sx={{width:"16px", height:"16px"}} component="img" src={helpImage}></Box>
            </MuiIconButton>;
  }
}

HelpImageViewerComponent.propTypes = {
  helpImages: PropTypes.shape( {} ), 
  filterName: PropTypes.string.isRequired, 
  filter: PropTypes.string, 
  selectorName: PropTypes.string.isRequired,
  setPopup: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired
};

export const HelpImageViewer = connect(combineStates( helpImagesState,identityState,siteSettingsState ),popupDispatcher)( HelpImageViewerComponent );